import apiClient from "../../../utilities/apiClient";

export const resetPassword = (payload) => {
  return apiClient.post(`${apiClient.Urls.resetPassword}`, payload);
};
